import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'applications';
export const applicationsActions = makeActions(MODEL_NAME);

export const getAllApplications = applicationsActions.getAll;
export const editApplications = applicationsActions.edit;
export const createApplications = applicationsActions.create;
export const getByIdApplications = applicationsActions.getDataById;
